import React, { useContext, Fragment } from 'react';
import PageContext from '../../contexts/pageContext';
import useSectionStyles from './styles';
import Carousel from '../../components/carousel';
import Button from '../../components/button';
import NextImageRenderer from '../../components/nextImageRenderer';
import { wordBreakValue } from '../../utils/cssUtils';
const Section = ({ nodeData, sectionIndex, extraProps }) => {
  const {
    layout: { containerWidth },
    isMobile,
    isCustomWebsite,
    countryCode
  } = useContext(PageContext);

  const hasContent = Boolean(
    nodeData.cardHeading.metadata.value ||
      nodeData.title.metadata.valu ||
      nodeData.description.metadata.value
  );

  const mobileImageSrc = isMobile && nodeData?.mobileImage?.metadata?.value;
  const desktopImageSrc = nodeData?.image?.metadata?.value;

  const classes = useSectionStyles({
    wordBreakValue: wordBreakValue(countryCode),
    imageUrl: nodeData.image.metadata.value,
    containerWidth,
    isCustomWebsite,
    hasContent,
    mobileImage: nodeData?.mobileImage?.metadata?.value
  });

  const handleButton = () => {
    console.log('buy now clicked');
    extraProps?.courseBuyNow();
  };

  return (
    <section className={classes.bannerCarouselCenterSection}>
      <div
        className={
          mobileImageSrc
            ? classes.contentContainerWithMobile
            : classes.contentContainer
        }
      >
        <div className={classes.sectionContainer}>
          {!(
            nodeData.cardHeading.metadata.value === '<br>' &&
            nodeData.title.metadata.value === '<br>' &&
            nodeData.description.metadata.value === '<br>' &&
            nodeData?.cta?.metadata?.value === ''
          ) ? (
            <div
              className={
                mobileImageSrc
                  ? classes.textContainerWithMobile
                  : classes.textContainer
              }
            >
              {nodeData.cardHeading.metadata.value !== '<br>' ? (
                <div
                  className={
                    mobileImageSrc
                      ? classes.subTitleHeadingWithMobile
                      : classes.subTitleHeading
                  }
                >
                  <span
                    ref={nodeData?.cardHeading?.refSetter}
                    dangerouslySetInnerHTML={{
                      __html: nodeData.cardHeading.metadata.value
                    }}
                  />
                </div>
              ) : null}

              {nodeData.title.metadata.value !== '<br>' ? (
                <h2
                  className={
                    mobileImageSrc ? classes.headingWithMobile : classes.heading
                  }
                >
                  <span
                    ref={nodeData?.title?.refSetter}
                    dangerouslySetInnerHTML={{
                      __html: nodeData.title.metadata.value
                    }}
                  />
                </h2>
              ) : null}

              {nodeData.description.metadata.value !== '<br>' ? (
                <p
                  ref={nodeData?.description?.refSetter}
                  className={
                    mobileImageSrc
                      ? classes.descriptionWithMobile
                      : classes.description
                  }
                  dangerouslySetInnerHTML={{
                    __html: nodeData.description.metadata.value
                  }}
                />
              ) : null}

              {nodeData?.cta?.validations?.isEmptyAllowed &&
              nodeData?.cta?.metadata?.value === '' ? null : (
                <div className={classes.buttonClass}>
                  {nodeData?.cta?.metadata?.default === true ? (
                    <Button
                      data={nodeData.cta.metadata}
                      ref={nodeData?.cta?.refSetter}
                      type={nodeData?.cta?.metadata?.type}
                      size={isMobile ? 'small' : 'medium'}
                      onClick={handleButton}
                    />
                  ) : (
                    <Button
                      ref={nodeData?.cta?.refSetter}
                      data={nodeData.cta.metadata}
                      type={nodeData?.cta?.metadata?.type}
                      size={isMobile ? 'small' : 'medium'}
                    />
                  )}
                </div>
              )}
            </div>
          ) : null}
        </div>
        <div
          className={
            mobileImageSrc
              ? classes?.centerBgImageContainerWithMobile
              : classes?.centerBgImageContainer
          }
        >
          <div className={hasContent && classes?.overlay}></div>
          <NextImageRenderer
            src={mobileImageSrc ? mobileImageSrc : desktopImageSrc}
            className={classes?.centerBgImage}
            sectionIndex={sectionIndex}
          />
        </div>
      </div>
    </section>
  );
};
export default function BannerCarouselCenter({
  sectionData,
  isCustomWebsite,
  sectionIndex,
  extraProps
}) {
  const classes = useSectionStyles({ isCustomWebsite });
  const [{ bannerCarousel }] = sectionData.components;

  const Wrapper = bannerCarousel.components.length > 1 ? Carousel : Fragment;
  const wrapperProps =
    bannerCarousel.components.length > 1
      ? { buttonContainerClass: classes.absoluteButtons, inverted: true }
      : {};
  return (
    <section className={classes.bannerCarouselCenterSection}>
      <Wrapper {...wrapperProps}>
        {bannerCarousel.components.map((node, idx) => (
          <Section
            nodeData={node}
            isCustomWebsite={isCustomWebsite}
            key={idx /* or some other unique property */}
            sectionIndex={sectionIndex}
            extraProps={extraProps}
          />
        ))}
      </Wrapper>
    </section>
  );
}
